import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setProviderRolesOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* getProviderRolesOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getProviderRolesOptions])
    const { entity } = response
    if (entity) yield put(setProviderRolesOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getProviderRolesOptions() error: ${e}`))
  }
}

export function* getProviderRolesOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getProviderRolesOptions)
}
